import {
    getProduct,
    listProducts
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    GetProduct,
    ListProducts
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient({
                                  // endpoint: billingApiAppSyncConfig.endpoint,
                                  // authMode: 'userPool'
                              });


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                          query: (listProducts),
                                                                          variables: {
                                                                              filter: filter
                                                                          },
                                                                      });
    return response.data?.listProducts.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                        query: (getProduct),
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getProduct;
};
